import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 kn-flex" }
const _hoisted_2 = { class: "p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = { class: "kn-flex kn-relative" }
const _hoisted_4 = {
  id: "driver-details-container",
  class: "p-m-2"
}
const _hoisted_5 = { class: "p-field p-col-12" }
const _hoisted_6 = { class: "p-float-label " }
const _hoisted_7 = {
  for: "dataSource",
  class: "kn-material-input-label"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_11 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InlineMessage = _resolveComponent("InlineMessage")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.dataLineage.title')), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: _ctx.mainDescriptor.style.absoluteScroll
        }, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--default" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.availableTables')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Card, null, {
              content: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_Dropdown, {
                      id: "dataSource",
                      class: "kn-material-input kn-width-full",
                      modelValue: _ctx.dataSource,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataSource = $event)),
                      options: _ctx.metaSourceResource,
                      onChange: _ctx.getTablesBySourceID,
                      optionLabel: "name"
                    }, null, 8, ["modelValue", "options", "onChange"]),
                    _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('documentExecution.documentDetails.dataLineage.selectSource')), 1)
                  ])
                ]),
                (_ctx.metaSourceResource.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, [
                      _createVNode(_component_InlineMessage, {
                        severity: "info",
                        class: "kn-width-full"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.dataLineage.noDatasources')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.dataSource && _ctx.tablesList.length == 0 && _ctx.metaSourceResource.length != 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode(_component_InlineMessage, {
                        severity: "info",
                        class: "kn-width-full"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.documentDetails.dataLineage.noTables')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_ProgressBar, {
                      key: 2,
                      class: "kn-progress-bar",
                      mode: "indeterminate",
                      "data-test": "progress-bar"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dataSource && _ctx.tablesList.length > 0 && !_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_DataTable, {
                      key: 3,
                      class: "p-datatable-sm kn-table",
                      value: _ctx.tablesList,
                      selection: _ctx.selectedTables,
                      "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedTables = $event)),
                      dataKey: "tableId",
                      responsiveLayout: "scroll",
                      filters: _ctx.filters,
                      "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters = $event)),
                      globalFilterFields: _ctx.globalFilterFields,
                      onRowSelect: _ctx.peristTable,
                      onRowUnselect: _ctx.deleteTable
                    }, {
                      header: _withCtx(() => [
                        _createVNode("div", _hoisted_10, [
                          _createVNode("span", _hoisted_11, [
                            _hoisted_12,
                            _createVNode(_component_InputText, {
                              class: "kn-material-input",
                              modelValue: _ctx.filters['global'].value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                              placeholder: _ctx.$t('common.search')
                            }, null, 8, ["modelValue", "placeholder"])
                          ])
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          class: "lineage-table-header",
                          selectionMode: "multiple",
                          headerStyle: _ctx.mainDescriptor.style.tableHeader
                        }, null, 8, ["headerStyle"]),
                        _createVNode(_component_Column, {
                          field: "name",
                          header: _ctx.$t('managers.datasetManagement.flatTableName'),
                          sortable: true
                        }, null, 8, ["header"])
                      ]),
                      _: 1
                    }, 8, ["value", "selection", "filters", "globalFilterFields", "onRowSelect", "onRowUnselect"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ], 4)
      ])
    ])
  ]))
}